import { ApiResponse } from './types';
import { apiClient } from './core/apiClient';
import {
  IConsentRequest,
  ICreateConsentRequestInput,
  IRevokeConsentInput,
  IRespondConsentInput,
} from '../types/interfaces/IConsent';

export async function createConsent(
  payload: ICreateConsentRequestInput
): Promise<ApiResponse<IConsentRequest>> {
  return apiClient.post<IConsentRequest>('/consents', payload);
}

export async function getConsentById(
  consentId: string
): Promise<ApiResponse<IConsentRequest>> {
  return apiClient.get<IConsentRequest>(`/consents/${consentId}`);
}

export async function getConsents(filters: {
  institutionId: string;
  status?: string;
  partyStatus?: string;
  partyType?: string;
  from?: string;
  to?: string;
}): Promise<ApiResponse<IConsentRequest[]>> {
  return apiClient.get<IConsentRequest[]>('/consents', {
    institutionId: filters.institutionId,
    status: filters.status,
    partyStatus: filters.partyStatus,
    partyType: filters.partyType,
    from: filters.from,
    to: filters.to,
  });
}

export async function respondConsent(
  consentId: string,
  payload: IRespondConsentInput
): Promise<ApiResponse<IConsentRequest>> {
  return apiClient.post<IConsentRequest>(`/consents/${consentId}/respond`, payload);
}

export async function revokeConsent(
  consentId: string,
  payload?: IRevokeConsentInput
): Promise<ApiResponse<IConsentRequest>> {
  return apiClient.post<IConsentRequest>(`/consents/${consentId}/revoke`, payload || {});
}
